"use client"

import Couplet from "./_components/Couplet"
import Expansion from "./_components/Expansion"
import OneImg from "./_components/OneImg"
import RichTxt from "./_components/RichTxt"
import Swiper from "./_components/Swiper"
import Text from "./_components/Text"
import TileImg from "./_components/TileImg"
import Video from "./_components/Video"
import { SuffixProvider } from "./SuffixContext"
import { AdListType } from "./types"

export enum PosTypeEnum {
  ONEIMG = "单张图片",
  TEXT = "文字",
  RICHTEXT = "富文本",
  TILEIMG = "图片平铺",
  SWIPER = "图片轮播",
  EXPANSION = "扩充广告",
  COUPLET = "对联",
  VIDEO = "视频",
}

/**
 * 广告组件props
 * @param AdList 广告数据
 * @param style 样式
 * @param suffix 后缀
 */
export interface AdComponentProps {
  /** 广告数据 */
  AdList: AdListType
  /** 样式 */
  style?: React.CSSProperties
  /** 广告位图片后缀 */
  suffix?: string
}

const AdComponent = (props: AdComponentProps) => {
  const { AdList, style, suffix } = props
  const { ONEIMG, TEXT, TILEIMG, SWIPER, EXPANSION, VIDEO, RICHTEXT, COUPLET } = PosTypeEnum

  const renderFunc = () => {
    switch (AdList.pos_type) {
      case ONEIMG:
        return <OneImg AdList={AdList} style={style} />
      case TEXT:
        return <Text AdList={AdList} style={style} />
      case RICHTEXT:
        return <RichTxt AdList={AdList} style={style} />
      case TILEIMG:
        return <TileImg AdList={AdList} style={style} />
      case SWIPER:
        return <Swiper AdList={AdList} style={style} />
      case EXPANSION:
        return <Expansion AdList={AdList} style={style} />
      case VIDEO:
        return <Video AdList={AdList} style={style} />
      case COUPLET:
        return <Couplet AdList={AdList} style={style} />
      default:
        return <Text AdList={AdList} style={style} />
    }
  }
  return <SuffixProvider suffix={suffix || ""}>{renderFunc()}</SuffixProvider>
}
export default AdComponent
